import AbstractRepository from "@/repositories/AbstractRepository";

export interface News {
    uuid?: string;
    title: string;
    imageUrl?: string;
    beginDate?: string;
    endDate?: string;
    text?: string;
    owner?: {
        uuid: string;
    };
}
export default class NewsRepository extends AbstractRepository {
    protected static resource: string = "news";

    protected static defaultFields: string[] = [
        "uuid",
        "title",
        "link",
        "imageUrl",
        "text",
        "owner.uuid",
        "beginDate",
        "endDate",
    ];
}
